module.exports = __webpack_public_path__ + "img/Group 427323244.6160d800.png";